import React, { Component } from "react";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import projectSettings from "../../assets/Js/projectSettings";

import styles from "./SubscribeGym.module.css";

import SubscribeToPlateform from "../SubscribeToPlateform/SubscribeToPlateform";
import PricePlan from "../../Components/PricePlan/PricePlan";
const stripePromise = loadStripe(projectSettings.stripePublicKey);

export default class SubscribeGym extends Component {
  render() {
    return (
      <>
        <Elements stripe={stripePromise}>
          <div className={`${styles.container}`}>
            <div>
              <div className="text-center">
                <div className="h1 pt-5">Subscribe To Grow</div>
                <div className="lead mt-1 mb-4">
                Post workouts, accept payments, chat with your team, & much more!
                </div>
                <div className="d-flex justify-content-center">
                  <div className="ml-2">
                    <SubscribeToPlateform />
                  </div>
                </div>
              </div>
              <div className={`container rounded mt-3`}>
                <PricePlan />
              </div>
            </div>
          </div>
        </Elements>
      </>
    );
  }
}
